import { render, staticRenderFns } from "./ChannelAvatar.vue?vue&type=template&id=3216b20d&"
import script from "./ChannelAvatar.vue?vue&type=script&lang=js&"
export * from "./ChannelAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports